import { Grid, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";

const grandSeperator = val => {
  if(!val) {
		return "0"
	}
	
  val = val
    .toString()
    .replace(/,/g, "")
    .replace(/ /g, "");
  let parsed = parseFloat(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString().replace(/,/g, " ");
  } else {
    return val;
  }
};

const customRow = (firstCol, secondCol, thirdCol) => {
  return (
    <React.Fragment>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container>
          <GridItem xs={6} sm={6} md={6}>
            {firstCol}
          </GridItem>
          <GridItem xs={3} sm={3} md={3}>
            {secondCol}
          </GridItem>
          <GridItem xs={3} sm={3} md={3}>
            {thirdCol}
          </GridItem>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const ExecutorsFees = props => {
  const executorsFees = props.executorsFees;

  return (
    <React.Fragment>
      <Grid
        direction="column"
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Net Asset Value: </strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" }}>
            R {grandSeperator(executorsFees.assetTotal)}
          </Typography>
        )}

        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            Percentage applicable:
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            {executorsFees.percentageApplicable}%
          </Typography>,
          null
        )}

        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            VAT:
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            {executorsFees.VAT}%
          </Typography>,
          null
        )}

        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Executor fees: </strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" }}>
            R {grandSeperator(executorsFees.executorsFees)}
          </Typography>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default ExecutorsFees;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/ExecutorsFees.jsx